//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { handleSeconds } from '@/utils'
export default {
    data () {
        return {
            show: false,
            progress: 0
        }
    },
    props: {
        playing: Boolean,
        time: Number,
        running_time: Number
    },
    watch: {
        playing (latest, old) {
            if (latest && latest != old) {
                this.show = true
            }
        },
        running_time (latest) {
            if (this.time) {
                this.progress = parseInt((latest / this.time) * 100)
            }
        }
    },
    computed: {
        duration () {
            return handleSeconds(this.time)
        },
        running_duration () {
            return handleSeconds(this.running_time)
        }
    },
    methods: {
        onPress () {
            if (this.playing) {
                this.stop()
            } else {
                this.play()
            }
        },
        play () {
            this.$emit('play')
        },
        stop () {
            this.$emit('stop')
        },
        onClose () {
            this.show = false
            this.stop()
        },
        changeProgress (e) {
            console.log('change progress', e)
            this.progress = e.target.value
            this.$emit('seek', this.progress / 100)
        }
    }
}
